module.exports = __webpack_public_path__ + "img/5.72b10761.jpg";